var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNafhubLightLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 46,
    viewBox: "0 0 184 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    d: "M22.4309 26.9516C22.4309 21.8302 19.5994 19.0671 15.3207 19.0671C11.042 19.0671 8.0949 21.83 8.0949 26.9516V44.5637H0V12.6791H8.09465V16.6495C10.1762 13.9457 13.6453 12.2188 17.7488 12.2188C25.2059 12.2188 30.5253 17.0539 30.5253 25.8594V44.5657H22.4309V26.9536V26.9516Z",
    fill: "#001E81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M47.2423 12.2188C52.3836 12.2188 55.9058 14.6333 57.8124 17.2811V12.7384H65.9572V44.5977H57.8124V39.9389C55.9061 42.6988 52.268 45.1134 47.183 45.1134C39.0946 45.1134 32.625 38.4984 32.625 28.5511C32.625 18.6037 39.0946 12.219 47.2393 12.219L47.2423 12.2188ZM49.3206 19.2911C44.9889 19.2911 40.8853 22.5114 40.8853 28.5508C40.8853 34.5903 44.9859 38.0408 49.3206 38.0408C53.6553 38.0408 57.8122 34.7054 57.8122 28.6659C57.8122 22.6265 53.768 19.2911 49.3206 19.2911Z",
    fill: "#001E81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    d: "M76.2534 12.7991V11.4797C76.2534 7.92332 77.5785 6.66319 81.4946 6.77829L81.8185 6.78449V0.0202147L81.4946 0.0107886H81.3509C72.4624 -0.175999 68.0703 3.43646 68.0703 11.1935V44.5671H76.2494V19.3923H81.8375V12.7991H76.2534Z",
    fill: "#001E81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4",
    d: "M22.4309 26.9516C22.4309 21.8302 19.5994 19.0671 15.3207 19.0671C11.042 19.0671 8.0949 21.83 8.0949 26.9516V44.5637H0V12.6791H8.09465V16.6495C10.1762 13.9457 13.6453 12.2188 17.7488 12.2188C25.2059 12.2188 30.5253 17.0539 30.5253 25.8594V44.5657H22.4309V26.9536V26.9516Z",
    fill: "#0C1A60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    d: "M47.2423 12.2188C52.3836 12.2188 55.9058 14.6333 57.8124 17.2811V12.7384H65.9572V44.5977H57.8124V39.9389C55.9061 42.6988 52.268 45.1134 47.183 45.1134C39.0946 45.1134 32.625 38.4984 32.625 28.5511C32.625 18.6037 39.0946 12.219 47.2393 12.219L47.2423 12.2188ZM49.3206 19.2911C44.9889 19.2911 40.8853 22.5114 40.8853 28.5508C40.8853 34.5903 44.9859 38.0408 49.3206 38.0408C53.6553 38.0408 57.8122 34.7054 57.8122 28.6659C57.8122 22.6265 53.768 19.2911 49.3206 19.2911Z",
    fill: "#0C1A60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    d: "M76.2534 12.7991V11.4797C76.2534 7.92332 77.5785 6.66319 81.4946 6.77829L81.8185 6.78449V0.0202147L81.4946 0.0107886H81.3509C72.4624 -0.175999 68.0703 3.43646 68.0703 11.1935V44.5671H76.2494V19.3923H81.8375V12.7991H76.2534Z",
    fill: "#0C1A60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7",
    d: "M113.233 26.2941V44.5647H106.032V27.5862C106.032 21.9451 103.788 19.2039 99.172 19.2039C94.3464 19.2879 91.7867 22.0384 91.7867 27.1568V44.5655H84.6641V0H91.465V13.1552H91.4743V15.9526C93.5119 13.6035 96.6938 12.284 100.466 12.284H100.628C105.442 12.3401 108.948 14.0763 111.055 17.4491C112.855 20.3335 113.233 23.8524 113.233 26.2951V26.2941Z",
    fill: "#3C52CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M138.579 12.3906V30.4839C138.579 35.4778 136.035 38.1598 131.225 38.2409C126.58 38.2409 124.418 35.6363 124.418 30.0454V12.3906H116.195V31.367C116.195 33.9059 116.598 37.562 118.527 40.5699C120.743 44.0331 124.384 45.8563 129.353 45.9902L130.047 45.9997V45.9935C133.632 45.9592 136.735 44.8236 138.904 42.7732V45.1069H146.718V12.3906H138.579Z",
    fill: "#3C52CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 9",
    d: "M169.098 12.2406C163.853 12.2406 160.259 14.7048 158.315 17.4025V0H150.008V45.2625H158.315V40.5112C160.258 43.3272 163.969 45.7914 169.154 45.7914C177.401 45.7914 184.003 39.0457 184.003 28.8987C184.003 18.7516 177.405 12.2399 169.098 12.2399V12.2406ZM166.976 38.5761C162.437 38.5761 158.315 35.1723 158.315 29.0145C158.315 22.8567 162.437 19.4529 166.976 19.4529C171.514 19.4529 175.576 22.7354 175.576 28.8962C175.576 35.0569 171.395 38.5759 166.976 38.5759V38.5761Z",
    fill: "#3C52CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNafhubLightLogo);
export default __webpack_public_path__ + "static/media/nafhub-light-logo.6f2739724ceba96c8ee70bb09ebf125a.svg";
export { ForwardRef as ReactComponent };